import { useMediaQuery, useTheme } from "@material-ui/core";
import { useShimmerStyles } from "../styles";
import { DESKTOP_BREAKPOINT } from "../consts";

const Shimmer = ({ width, height, borderRadius, style = {} }) => {
  const classes = useShimmerStyles();
  return (
    <div
      className={classes.block}
      style={{ width, height, borderRadius, ...style }}
    />
  );
};

const HeaderShimmer = ({ isMobile, classes }) => (
  <div className={classes.headerWrapper}>
    <Shimmer
      width={isMobile ? "72px" : "100px"}
      height={isMobile ? "72px" : "100px"}
      borderRadius="16px"
    />
    <div className={classes.headerRight}>
      <div className={classes.nameRow}>
        <Shimmer width="180px" height="32px" />
        {!isMobile && (
          <>
            <Shimmer width="120px" height="36px" borderRadius="8px" />
            <Shimmer width="120px" height="36px" borderRadius="8px" />
          </>
        )}
      </div>
      <Shimmer width="220px" height="16px" />
      <div className={classes.chipsRow}>
        {[80, 90, 80, 90].map((w, i) => (
          <Shimmer key={i} width={`${w}px`} height="32px" borderRadius="20px" />
        ))}
      </div>
      <Shimmer width="220px" height="14px" />
      <Shimmer width="260px" height="14px" />
    </div>
    {!isMobile && (
      <Shimmer width="100px" height="100px" borderRadius="50%" />
    )}
  </div>
);

const StatsShimmer = ({ isMobile, classes }) => (
  <div className={classes.statsWrapper}>
    {Array.from({ length: isMobile ? 4 : 5 }).map((_, i) => (
      <div key={i} className={classes.statItem}>
        <Shimmer width="48px" height="48px" borderRadius="8px" />
        <Shimmer width="80px" height="28px" />
        <Shimmer width="100px" height="14px" />
      </div>
    ))}
  </div>
);

const ContentShimmer = ({ classes }) => (
  <div className={classes.contentWrapper}>
    <div className={classes.nameRow} style={{ justifyContent: "space-between" }}>
      <Shimmer width="220px" height="40px" />
      <Shimmer width="130px" height="36px" borderRadius="8px" />
    </div>

    <Shimmer width="100%" height="14px" />
    <Shimmer width="90%" height="14px" />
    <Shimmer width="70%" height="14px" />

    <div className={classes.divider} />

    <div className={classes.infoRow}>
      <Shimmer width="140px" height="16px" />
      <div className={classes.chipsRow}>
        {[110, 130, 120].map((w, i) => (
          <Shimmer key={i} width={`${w}px`} height="30px" borderRadius="20px" />
        ))}
      </div>
    </div>

    <div className={classes.infoRow}>
      <Shimmer width="160px" height="16px" />
      <Shimmer width="180px" height="16px" />
      <Shimmer width="180px" height="16px" />
    </div>

    <div className={classes.infoRow}>
      <Shimmer width="140px" height="16px" />
      <Shimmer width="160px" height="16px" />
      <Shimmer width="200px" height="16px" />
    </div>

    <div className={classes.divider} />

    <Shimmer width="180px" height="36px" />
    <div className={classes.chipsRow}>
      {[160, 180, 160, 140].map((w, i) => (
        <Shimmer key={i} width={`${w}px`} height="100px" borderRadius="12px" />
      ))}
    </div>
  </div>
);

export const MentorProfileShimmer = () => {
  const classes = useShimmerStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(DESKTOP_BREAKPOINT));

  return (
    <div className={isMobile ? classes.mobileWrapper : undefined}>
      <HeaderShimmer isMobile={isMobile} classes={classes} />
      <StatsShimmer isMobile={isMobile} classes={classes} />
      <ContentShimmer classes={classes} />
    </div>
  );
};
